export class DateRange {
    start: any;
    end: any;
    interval: string;
}
